import { apiInstance } from '@diamond/shared/utils';

type ItemType = { index: number };

export const getBanners = async (token: string, selectedShipToId: string) =>
  await apiInstance(token)
    .get(`/banner`, {
      params: {
        warehouse: selectedShipToId,
      },
    })
    .then((resp) => {
      return resp.data.sort((a: ItemType, b: ItemType) =>
        a.index > b.index ? 1 : b.index > a.index ? -1 : 0
      );
    })
    .catch((_error) => {
      return [];
    });
